import { useQuery } from '@tanstack/react-query';
import { apiRequest } from '@/lib/queryClient';

// Single source of truth for "who am I right now" — resolved fresh from the
// server (GET /api/me -> backend re-reads the DB from the JWT on every call),
// not the login-time snapshot persisted to localStorage. Route guards and nav
// visibility for seller/admin/kyc-gated UI should read this, not auth-context's
// `user`, so a mid-session promotion (e.g. admin approves a seller) takes
// effect without forcing a re-login.
export const meQueryKey = ['me'];

export function useMe(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: meQueryKey,
    queryFn: async () => {
      const res = await apiRequest('GET', '/api/me');
      return res.json();
    },
    enabled: options?.enabled ?? true,
    staleTime: 30000,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
  });
}
